import { render, staticRenderFns } from "./VQCheck.vue?vue&type=template&id=4f228c1f&scoped=true&"
import script from "./VQCheck.vue?vue&type=script&lang=js&"
export * from "./VQCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f228c1f",
  null
  
)

export default component.exports